import { SUBJECT_CODES } from "@repo/shared";
import { match } from "ts-pattern";

import type { SubjectCode } from "@repo/shared";
import type { GetAllSubjectsResponse } from "~/api/generated-api";

const getOrder = (code: SubjectCode | null): number =>
  match(code)
    .with(SUBJECT_CODES.MATH, () => 1)
    .with(SUBJECT_CODES.ENGLISH, () => 2)
    .with(SUBJECT_CODES.POLISH, () => 3)
    .otherwise(() => 4);

export const sortSubjects = (subjects?: GetAllSubjectsResponse["data"]) =>
  (subjects ?? []).sort((a, b) => {
    const orderA = getOrder(a.code);
    const orderB = getOrder(b.code);

    return orderA - orderB;
  });
